module.exports = __webpack_public_path__ + "static/dynamic-e9c0bc35d890d2a2e4009f9eef7d8af0.png";